import { useParams } from 'react-router-dom'

export default function useMode() {
  const { mode = 'normal' } = useParams()

  return {
    mode: mode as 'normal' | 'verify',
  }
}
